<div class="d-flex justify-content-between align-items-center px-4 gap-4 w-100">
  <div class="title font-weight-600 font-size-16 line-height-20 color-gray-900">
    {{ title() }}
  </div>

  <div class="alert-pagination-container d-flex align-items-center gap-2">
    <div class="white-space-nowrap font-size-12 font-weight-400 line-height-16">{{ currentIndex() + 1 }} of {{ total() }}</div>
    <div class="arrow-btn-container d-flex align-items-center gap-8">
      <button
        type="button"
        class="btn btn-icon btn-icon-transparent"
        [disabled]="!currentIndex() || isControlsDisabled()"
        (click)="moveToPrevious.emit()"
      >
        <i class="icon ic-arrow-left-20"></i>
      </button>

      <button
        type="button"
        class="btn btn-icon btn-icon-transparent"
        [disabled]="currentIndex() + 1 >= total() || isControlsDisabled()"
        (click)="moveToNext.emit()"
      >
        <i class="icon ic-arrow-right-20"></i>
      </button>
    </div>
  </div>
</div>
